import mediumEmphasis from '../../text/medium-emphasis';

const secondary = (params) => mediumEmphasis(params);

export default secondary;
